import { useSession } from '@/auth/useSession';
import { AlertBanner } from '@/components/alert-banner';

export const ImpersonationAlertBanner = () => {
  const { isImpersonating, actingUser } = useSession();

  if (!isImpersonating) return null;

  return (
    <AlertBanner
      title={`Impersonating ${actingUser.fullName}`}
      content={
        <p>
          You are impersonating {actingUser.fullName}. All data you see is from {actingUser.fullName}. All actions will
          be performed as {actingUser.fullName}.
        </p>
      }
    />
  );
};
